import { paymentRequest } from "src/handler/accountHandler";
import Alert from "../Payment/Alert"
import ReactDOM from "react-dom";
export const RazorPayPayment = async (
  amount: number,
  packageId: number,
  sponsorId: string,
  itemIds: number[] | null
) => {
  try {
    
    const response = await paymentRequest({
      amount,
      isVerify: false,
    });

    const { amount: orderAmount, currency, orderId } =
      response.data.paymentCreateResponse;

    const options = {
      // key: "rzp_test_TBm703ZKpL6nMQ",
      key: "rzp_live_TBn52b1tKUN8vF",
      amount: orderAmount,
      currency,
      order_id: orderId,
      name: "Growniverse",
      description: "Growniverse Transaction",
      handler: async function (res: any) {
        try {
          
          const verifyResponse = await paymentRequest({
            amount: orderAmount / 100,
            isVerify: true,
            orderId: res.razorpay_order_id,
            paymentId: res.razorpay_payment_id,
            signature: res.razorpay_signature,
            packageId: packageId,
            couponCode: sponsorId,
            courses: itemIds
          });
          if(verifyResponse.statusCode === 201)
          {
            ReactDOM.render(<Alert message="✅ Payment successful!" severity="success" />, document.getElementById("alert-root"));
            window.location.reload();
          }
          else if(verifyResponse.statusCode === 402)
          {
            ReactDOM.render(<Alert message=" Payment Failed!" severity="success" />, document.getElementById("alert-root"));
            

          }
        } catch (error) {
            
         
        }
            

      },
      theme: { color: "#3399cc" },
    };

    const rzp = new (window as any).Razorpay(options);
    rzp.open();
  } catch (error) {
    console.error("Payment initiation failed:", error);
            

  }
};
